import { render, staticRenderFns } from "./ModalSectionStatusMenuContent.vue?vue&type=template&id=31c611f5"
import script from "./ModalSectionStatusMenuContent.vue?vue&type=script&lang=js"
export * from "./ModalSectionStatusMenuContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports